module.exports = __webpack_public_path__ + "static/media/vendor.343fe32e.svg";